@if (showCustomerError) {
  @if (customer()?.customerError || errorInAllowanceCheck) {
    <div class="error-message-container">
      @if (customer()?.customerError) {
        <app-ice-alert type="error" [iconName]="size === 'regular' ? IconNames.ice_warning : null">
          <div heading>Kunne ikke gjennomføre kredittsjekken</div>
          <div class="creditcheck-error-text">{{ customer()?.customerError }}</div>
        </app-ice-alert>
      }
      @if (displayCreditCheckError && !customer()?.isLoadingCustomerCreditCheck) {
        <app-ice-alert type="error" [iconName]="size === 'regular' ? IconNames.ice_thumbs_down : null">
          <div heading>Kredittsjekk ikke godkjent</div>
          @if (customer().authorizeResult.reason; as reason) {
            <div class="creditcheck-error-text">
              {{ reason }}
            </div>
          } @else if (customer().authorizeResult.subscriptionAllowance?.reason) {
            <div class="creditcheck-error-text">
              {{ customer().authorizeResult.subscriptionAllowance.reason }}
            </div>
          } @else if (customer()?.isExistingCustomer && customer().authorizeResult?.downPaymentAllowance?.reason) {
            <div class="creditcheck-error-text">
              {{ customer().authorizeResult.downPaymentAllowance.reason }}
            </div>
          }
        </app-ice-alert>
      }
    </div>
  }
}
@if (showCreditCheckForm) {
  <form
    class="existing-customer-creditcheck-form"
    ngxsForm="formState.customerAllowanceForm"
    [formGroup]="customerCreditCheckForm"
    [ngClass]="{ small: size === 'small' }"
  >
    <app-ice-input-field
      formControlName="ssn"
      inputWidth="medium"
      label="Fødselsnummer"
      ngDefaultControl
      ngxsFormPath="formState.customerAllowanceForm"
      textTestId="ssn-input"
      [maxLength]="11"
    />
    <app-ice-button
      color="secondary"
      size="large"
      testId="submit-extended-credit-check-button"
      type="submit"
      [disabled]="customerCreditCheckForm.invalid"
      (click)="runCreditCheck()"
    >
      Kredittsjekk
    </app-ice-button>
  </form>
  @if (isCustomerNameInvalid) {
    <app-ice-alert type="error">
      <div heading>Ugyldig tegn i navn</div>
      <div>
        Ta kontakt med kundeservice for å få hjelp
        <br />
        til å oppdatere kundeinformasjonen.
      </div>
    </app-ice-alert>
  }
  <p>Kunden vil få gjenpartsbrev i posten.</p>
  @if (
    customer()?.isLoadingCustomer ||
    customer()?.isLoadingCustomerCreditCheck ||
    customer()?.isLoadingCustomerDownPaymentCheck
  ) {
    <app-spinner />
  }
}
